import { render, staticRenderFns } from "./team-form-page.vue?vue&type=template&id=eafd1a2e&"
import script from "./team-form-page.vue?vue&type=script&lang=js&"
export * from "./team-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports